// Ensure we only execute one mutation per ticket per client at a
// time - this solves a lot of race conditions, for instance when quickly switching between
// orders. We do this by creating a promise chain per ticket
const ticketCommandQueue = {};

const executeTicketCommand = (ticketId, command) => {
  const promise =
    ticketId in ticketCommandQueue ? ticketCommandQueue[ticketId].then(command) : command();
  // NOTE: catch so that we never break the promise chain when commands have failed
  ticketCommandQueue[ticketId] = promise.catch(() => {});
  return promise;
};

export default executeTicketCommand;



// WEBPACK FOOTER //
// ../utils/functions/execute-ticket-command/index.js